import Vue from "vue";
import Router from "vue-router";
/**
 * 重写路由的push方法 解决首次进入路由相同报错
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(Router);

import WorkShopEquipDetail from "../views/workshop/WorkShopEquipDetail.vue";
import WorkShopGlobalChart from "../views/workshop/WorkShopGlobalChart.vue";
import TechnologyConfig from "../views/TechnologyConfig.vue";

// import OrderMgt from '../views/OrderMgt.vue';
import Report from "../views/Report.vue";

import UnqualifiedReport from "../views/report/qualityReport/UnqualifiedReport.vue";

import Warning from "../views/Warning.vue";
import WarningIpc from "../views/WarningIpc.vue";

import DataCollection from "../views/DataCollection.vue";
import Realtime from "../views/Realtime.vue";
import MaintainConf from "../views/devicecare/MaintainConf.vue";
import DeviceGroup from "../views/devicecare/deviceGroup.vue";

import FileMgt from "../views/masterdata/FileMgt.vue";

import MasterDataConfig from "../views/masterdata/MasterDataConfig.vue";
import QRCodeConfig from "../views/masterdata/QRCodeConfig.vue";
import PersonInfo from "../views/PersonInfo.vue";

import SalaryReport from "../views/report/SalaryReport.vue";
import ProductionReport from "../views/report/productionReport/index.vue";
import StoreManagement from "../views/stock/StoreManagement.vue";
import Repertory from "../views/stock/Repertory.vue";
import NoticeOfArrival from "../views/stock/NoticeOfArrival.vue";
import IncomingInspection from "../views/stock/IncomingInspection.vue";
import RecordsOfStoreEnter from "../views/stock/RecordsOfStoreEnter.vue";
import RecordsOfStoreOut from "../views/stock/RecordsOfStoreOut.vue";
import InventoryRecords from "../views/stock/InventoryRecords";
import InventoryTask from "../views/stock/InventoryTask";
import PickMaterialTask from "../views/stock/PickMaterialTask";
import MonthlySummary from "../views/stock/MonthlySummary";
import RoleConf from "../views/Role/RoleConf";
import WorkingCalendar from "../views/Organization/workingCalendar";
import OrganizationConf from "../views/Organization/OrganizationConf";
import ProtocolMgt from "../views/protocol/ProtocolMgt";
import DtuMgt from "../views/masterdata/DtuMgt";
import AlarmHistory from "../views/alarm/alarmHistory";
import AlarmMgt from "../views/alarm/alarmMgt";
import ProductionReportInfo from "../views/report/ProductionReportInfo";
//import OrderReport from '../views/report/OrderReport';
import CustomReport from "../views/report/CustomReport/index.vue";
import CustomReportAddDialog from "../views/report/CustomReport/CustomReportAddDialog.vue";
import CustomReportEditDialog from "../views/report/CustomReport/CustomReportEditDialog.vue";
import ViewCustomReport from "../views/report/CustomReport/ViewCustomReport.vue";
import MaintenanceOrderReport from "../views/report/maintenanceOrderReport";
import DevicecareReport from "../views/report/devicecareReport";
import MessageCenter from "../views/masterdata/MessageCenter";
import OrderGantt from "../views/gantt/orderGantt";
import MaterialGantt from "../views/gantt/materialGantt";
import TechnologyGantt from "../views/gantt/technologyGantt";
import UserGantt from "../views/gantt/userGantt";
import PurchaseCenter from "../views/order/PurchaseCenter";
import DispatchTask from "../views/order/DispatchTask/index";
import CompleteTask from "../views/order/CompleteTask/index";
import TaskAudit from "../views/order/CompleteTask/TaskAudit";
import ProgressOfProduction from "../views/order/SalesOrder/ProgressOfProduction";
import DeviceGantt from "../views/gantt/deviceGantt";

import BaseInspectConfig from "../views/devicecare/BaseInspectConfig";
import Schedule from "../views/Schedule";

import FactoryModel from "../views/FactoryModel/FactoryModel";
import ProductionTask from "../views/order/ProductionTask/index";
import ProductionRework from "../views/Rework/ReworkTask";
import ReworkTechnology from "../views/Rework/ReworkTechnology";
import ReworkRecord from "../views/Rework/ReworkRecord";
import OtherRecord from "../views/Rework/OtherRecord";
import PerformanceInspect from "../views/Rework/PerformanceInspect";

import CapacityOfProduction from "../views/Production/CapacityOfProduction";

import Productionflow from "../views/Productionflow";
import SalesOrder from "../views/order/SalesOrder/index";

import TechnologyTemplate from "../views/TechnologyBOM/TechnologyTemplate";
import ProcedureMapWorkshop from "../views/TechnologyBOM/ProcedureMapWorkshop";

import Technology from "../views/TechnologyBOM/Technology";
// import DispatchReport from '../views/report/DispatchReport'
// import DispatchRecord from '../views/report/DispatchRecord'

import TraceList from "../views/trace/TraceList";
import ExceptionSet from "../views/alarm/exceptionSet";
import Activation from "../views/activation/activationList";

import ForwardTracking from "../views/productTracking/ForwardTracking";
import ReverseTracking from "../views/productTracking/ReverseTracking";

import CustomPrint from "../views/customPrint/index.vue";
import CustomAddPrint from "@/views/customPrint/PrintAdd.vue";
import CustomEditPrint from "@/views/customPrint/PrintEdit.vue";
// import WipReport from '@/views/report/WipReport.vue';
import CodeMgt from "../views/masterdata/CodeMgt.vue";
import Dictionary from "../views/masterdata/Dictionary.vue";
import ClientMgt from "../views/masterdata/ClientMgt.vue";

import DealConfig from "../views/alarm/DealConfig.vue";
import ExceptionConfig from "../views/alarm/ExceptionConfig/index.vue";
import ExceptionList from "../views/alarm/ExceptionList/index.vue";
import ERPIframe from "../views/ERPIframe.vue";
export default new Router({
  routes: [
    {
      path: "/",
      component: resolve => require(["@/components/common/Home.vue"], resolve),
      meta: { title: "首页-物源科技", keepAlive: true },
      children: [
        { path: "/", component: resolve => require(["@/views/material/Material.vue"], resolve), meta: { title: "物料管理", keepAlive: true }, name: "AppCenter" },
        {
          path: "/DeviceCare/DeviceMgt",
          component: resolve => require(["@/views/masterdata/DeviceMgt.vue"], resolve),
          meta: { title: "设备台账", permission: "btn_device_listDeviceMgt", keepAlive: true },
          name: "DeviceMgt"
        },
        {
          path: "/Tool/ToolMgt",
          component: resolve => require(["@/views/Tool/ToolMgt.vue"], resolve),
          meta: { title: "模具基础数据", permission: "btn_tool_listTool", keepAlive: true },
          name: "ToolMgt"
        },
        {
          path: "/Tool/ToolPlan",
          component: resolve => require(["@/views/Tool/ToolPlan.vue"], resolve),
          meta: { title: "模具保养计划", permission: "btn_tool_listTool-1", keepAlive: true },
          name: "ToolPlan"
        },
        {
          path: "/Tool/ToolCare",
          component: resolve => require(["@/views/Tool/ToolCare.vue"], resolve),
          meta: { title: "模具维保工单", permission: "btn_tool_workOrderList", keepAlive: true },
          name: "ToolCare"
        },
        {
          path: "/Tool/ToolRecord",
          component: resolve => require(["@/views/Tool/ToolRecord.vue"], resolve),
          meta: { title: "模具使用维保记录", permission: "btn_tool_listTool-2", keepAlive: true },
          name: "ToolRecord"
        },
        { path: "/MasterData/ProtocolMgt", component: ProtocolMgt, meta: { title: "协议管理" }, name: "ProtocolMgt" },
        {
          path: "/MasterData/ProductMgt",
          component: resolve => require(["@/views/masterdata/ProductMgt.vue"], resolve),
          meta: { title: "产品管理", permission: "btn_product_listProductMgt", keepAlive: true },
          name: "ProductMgt"
        },
        {
          path: "/MasterData/UserMgt",
          component: resolve => require(["@/views/masterdata/UserMgt.vue"], resolve),
          meta: { title: "用户管理", permission: "btn_user_listUserMgt", keepAlive: true },
          name: "UserMgt"
        },
        {
          path: "/MasterData/UserGroup",
          component: resolve => require(["@/views/masterdata/UserGroup.vue"], resolve),
          meta: { title: "执行组管理", permission: "btn_executionGroup_page", keepAlive: true },
          name: "UserGroup"
        },
        {
          path: "/MasterData/TeamList",
          component: resolve => require(["@/views/masterdata/TeamList.vue"], resolve),
          meta: { title: "班组管理", permission: "btn_team_page", keepAlive: true },
          name: "TeamList"
        },
        { path: "/MasterData/QRCodeConfig", component: QRCodeConfig, meta: { title: "条码配置", permission: "btn_codeRule_listCodeRule", keepAlive: true }, name: "QRCodeConfig" },
        { path: "/MasterData/FileMgt", component: FileMgt, meta: { title: "附件管理", permission: "btn_fileSys_list", keepAlive: true }, name: "FileMgt" },
        { path: "/MasterData/MessageCenter", component: MessageCenter, meta: { title: "消息中心", keepAlive: true }, name: "MessageCenter" },
        { path: "/MachineInterconnection/DtuMgt", component: DtuMgt, meta: { title: "DTU管理", permission: "btn_dtu_list", keepAlive: true }, name: "DtuMgt" },
        { path: "/DeviceCare/CheckConf", component: BaseInspectConfig, meta: { title: "点检配置", permission: "btn_inspectionConfig_list", keepAlive: true }, name: "BaseInspect" },
        { path: "/DeviceCare/MaintainConf", component: MaintainConf, meta: { title: "维修模板", permission: "btn_repairTemplate_list", keepAlive: true }, name: "MaintainConf" },
        { path: "/DeviceCare/DeviceGroup", component: DeviceGroup, meta: { title: "设备组管理", permission: "btn_deviceGroup_listDeviceGroup", keepAlive: true }, name: "DeviceGroup" },

        {
          path: "/DeviceCare/CarePlan",
          component: resolve => require(["@/views/devicecare/CarePlan.vue"], resolve),
          meta: { title: "保养计划", permission: "btn_maintenance_listDevice", keepAlive: true },
          name: "CarePlan"
        },
        {
          path: "/DeviceCare/BaseCareOrder",
          component: resolve => require(["@/views/devicecare/BaseCareOrder.vue"], resolve),
          meta: { title: "工单管理", permission: "btn_workOrder_list", keepAlive: true },
          name: "BaseCareOrder"
        },
        {
          path: "/MachineInterconnection/WorkShop",
          component: resolve => require(["@/views/WorkShop.vue"], resolve),
          meta: { title: "可视化机组", permission: "btn_workshop_getDataModelList", keepAlive: true },
          name: "WorkShop"
        },
        { path: "/Data/Realtime", component: Realtime, meta: { title: "实时数据", keepAlive: true }, name: "Realtime" },
        {
          path: "/Mission/MissionMgt",
          component: resolve => require(["@/views/mission/MissionMgt.vue"], resolve),
          meta: { title: "事务汇总", permission: "btn_mission_list", keepAlive: true },
          name: "MissionMgt"
        },
        { path: "/Data/History", component: DataCollection, meta: { title: "历史数据", keepAlive: true }, name: "History" },
        { path: "/WorkShopEquipDetail", component: WorkShopEquipDetail, meta: { title: "设备详情", keepAlive: true }, name: "workShopEquipDetail" },
        { path: "/WorkShopGlobalChart", component: WorkShopGlobalChart, param: { workshopId: null }, meta: { title: "机组概览", keepAlive: true }, name: "workShopGlobalChart" },
        { path: "/TechnologyConfig", component: TechnologyConfig, meta: { title: "工艺路线模板", permission: "btn_technologyTemplate_list", keepAlive: true }, name: "TechnologyConfig" },
        {
          path: "/Production",
          component: resolve => require(["@/views/Production.vue"], resolve),
          meta: { title: "生产任务", permission: "btn_plan_listProductionPlan", keepAlive: true },
          name: "Production"
        },
        { path: "/Warning/Productflow", component: Productionflow, meta: { title: "流转异常", permission: "btn_productionFlow_list", keepAlive: true }, name: "Productionflow" },
        { path: "/Schedule", component: Schedule, meta: { title: "生产进度", permission: "btn_order_listSplitProcess", keepAlive: false }, name: "Schedule" },
        { path: "/Production/OrderGantt", component: OrderGantt, meta: { title: "订单视图", permission: "btn_order_ganttChartList", keepAlive: true }, name: "OrderGantt" },
        // { path: "/Production/Wip", component: WipReport, meta: { title: '在制品管理', permission: 'btn_productionTask_list', keepAlive: true }, name: 'WipReport'},

        { path: "/Production/MaterialGantt", component: MaterialGantt, meta: { title: "物料视图", permission: "btn_gantt_getOrder", keepAlive: true }, name: "MaterialGantt" },
        { path: "/Production/TechnologyGantt", component: TechnologyGantt, meta: { title: "工序视图", permission: "btn_gantt_getOrder", keepAlive: true }, name: "TechnologyGantt" },
        { path: "/Production/UserGantt", component: UserGantt, meta: { title: "工人负荷", permission: "btn_gantt_getUser", keepAlive: true }, name: "UserGantt" },

        {
          path: "/Production/SelectionStatistics",
          component: resolve => require(["@/views/order/SelectionStatistics/index.vue"], resolve),
          meta: { title: "挑选统计", permission: "btn_businessOrderDispatch_listBusinessOrderDispatch", keepAlive: true },
          name: "SelectionStatistics"
        },
        { path: "/Production/TaskAudit", component: TaskAudit, meta: { title: "报工核查", permission: "btn_businessOrderDispatch_listBusinessOrderDispatch", keepAlive: true }, name: "TaskAudit" },
        {
          path: "/Production/CompleteTask",
          component: CompleteTask,
          meta: { title: "批量完工", permission: "btn_businessOrderDispatch_listBusinessOrderDispatch", keepAlive: true },
          name: "CompleteTask"
        },
        {
          path: "/Production/DispatchTask",
          component: DispatchTask,
          meta: { title: "派工单", permission: "btn_businessOrderDispatch_listBusinessOrderDispatch", keepAlive: true },
          name: "DispatchTask"
        },
        { path: "/Production/PurchaseCenter", component: PurchaseCenter, meta: { title: "采购管理", permission: "btn_purchase_listPurchase", keepAlive: true }, name: "PurchaseCenter" },
        {
          path: "/Production/ProgressOfProduction",
          component: ProgressOfProduction,
          meta: { title: "销售订单进度", permission: "btn_productionSchedule_list", keepAlive: true },
          name: "ProgressOfProduction"
        },
        { path: "/Production/CustomPrint", component: CustomPrint, meta: { title: "自定义流转卡", permission: "btn_productionSchedule_list", keepAlive: true }, name: "CustomPrint" },
        { path: "/Production/CustomAddPrint", component: CustomAddPrint, meta: { title: "新增自定义流转卡", permission: "btn_productionSchedule_list", keepAlive: true }, name: "CustomAddPrint" },
        { path: "/Production/CustomEditPrint", component: CustomEditPrint, meta: { title: "编辑自定义流转卡", permission: "btn_productionSchedule_list", keepAlive: true }, name: "CustomEditPrint" },
        { path: "/Production/DeviceGantt", component: DeviceGantt, meta: { title: "设备负荷", permission: "btn_gantt_getDevice", keepAlive: true }, name: "DeviceGantt" },
        // { path: "/OrderMgt", component: OrderMgt, meta: { title: '订单管理', permission: 'btn_order_listBusinessOrder', keepAlive: true }, name: 'OrderMgt'},
        { path: "/Report", component: Report, meta: { title: "报表管理", keepAlive: true }, name: "Report" },
        { path: "/Report/SalaryReport", component: SalaryReport, meta: { title: "员工绩效", permission: "btn_report_listWorkerProcessCount", keepAlive: true }, name: "SalaryReport" },

        // { path: "/Report/OrderReport", component: OrderReport, meta: { title: '生产报表', permission: 'btn_report_listReport', keepAlive: true }, name: 'OrderReport'},
        { path: "/Report/CustomReport", component: CustomReport, meta: { title: "自定义报表", permission: "btn_customTable_listReportData", keepAlive: true }, name: "CustomReport" },
        {
          path: "/Report/CustomReportEditDialog",
          component: CustomReportEditDialog,
          meta: { title: "编辑报表", permission: "btn_report_listReport", keepAlive: true },
          name: "CustomReportEditDialog"
        },
        { path: "/Report/ViewCustomReport", component: ViewCustomReport, meta: { title: "查看自定义报表", permission: "btn_report_listReport", keepAlive: true }, name: "ViewCustomReport" },
        { path: "/Report/CustomReportAddDialog", component: CustomReportAddDialog, meta: { title: "新增报表", permission: "btn_report_listReport", keepAlive: true }, name: "CustomReportAddDialog" },
        // { path: "/Report/OrderReport", component: OrderReport, meta: { title: '生产报表', permission: 'btn_report_workOrderProcessOutput', keepAlive: true }, name: 'OrderReport'},
        {
          path: "/Report/MaintenanceOrderReport",
          component: MaintenanceOrderReport,
          meta: { title: "设备运维报表", permission: "btn_report_listDevice", keepAlive: true },
          name: "MaintenanceOrderReport"
        },
        { path: "/Report/DevicecareReport", component: DevicecareReport, meta: { title: "设备报表", permission: "btn_report_deviceSummary", keepAlive: true }, name: "DevicecareReport" },
        { path: "/Report/ProductionReportInfo", component: ProductionReportInfo, meta: { title: "生产进度明细", permission: "btn_indexInfo_getBoard", keepAlive: true }, name: "ProductionReportInfo" },

        {
          path: "/Quality/ErrConf",
          component: resolve => require(["@/views/Quality/ErrConf.vue"], resolve),
          meta: { title: "不合格原因", permission: "btn_qcError_list", keepAlive: true },
          name: "ErrConf"
        },
        {
          path: "/Quality/Quality",
          component: resolve => require(["@/views/Quality/Quality/index.vue"], resolve),
          meta: { title: "质检任务", permission: "btn_qcTask_list", keepAlive: true },
          name: "Quality"
        },
        {
          path: "/Quality/QualityItem",
          component: resolve => require(["@/views/Quality/QualityItem.vue"], resolve),
          meta: { title: "项目配置", permission: "btn_qcItemConfig_list", keepAlive: true },
          name: "QualityItem"
        },
        {
          path: "/Quality/QualityConf",
          component: resolve => require(["@/views/Quality/QualityConf.vue"], resolve),
          meta: { title: "质检模板配置", permission: "btn_qcTemp_list", keepAlive: true },
          name: "QualityConf"
        },
        {
          path: "/Quality/QualityPrint",
          component: resolve => require(["@/views/Quality/QualityPrint.vue"], resolve),
          meta: { title: "质检方案", permission: "btn_qcScheme_listQcScheme", keepAlive: true },
          name: "QualityPrint"
        },
        {
          path: "/Quality/QcReport",
          component: resolve => require(["@/views/Quality/QcReport.vue"], resolve),
          meta: { title: "质检报表", permission: "btn_report_qc_task", keepAlive: true },
          name: "QcReport"
        },
        { path: "/Quality/UnqualifiedReport", component: UnqualifiedReport, meta: { title: "不良品分析", permission: "btn_report_qc_task_unqualified", keepAlive: true }, name: "UnqualifiedReport" },
        {
          path: "/Report/WipIndex",
          component: resolve => require(["@/views/report/WipReport/index.vue"], resolve),
          meta: { title: "在制品报表", permission: "btn_material_list", keepAlive: true },
          name: "WipIndex"
        },
        {
          path: "/Report/WorkInProcess",
          component: resolve => require(["@/views/report/WipReport/WorkInProcess.vue"], resolve),
          meta: { title: "在制品统计", permission: "btn_material_list", keepAlive: true },
          name: "WorkInProcess"
        },
        {
          path: "/Report/WipSluggish",
          component: resolve => require(["@/views/report/WipReport/WipSluggish.vue"], resolve),
          meta: { title: "在制品呆滞", permission: "btn_material_list", keepAlive: true },
          name: "WipSluggish"
        },
        {
          path: "/Report/WipLoad",
          component: resolve => require(["@/views/report/WipReport/WipLoad.vue"], resolve),
          meta: { title: "在制品负荷", permission: "btn_material_list", keepAlive: true },
          name: "WipLoad"
        },
        {
          path: "/Report/WipDeliveryMonitoring",
          component: resolve => require(["@/views/report/WipReport/WipDeliveryMonitoring.vue"], resolve),
          meta: { title: "在制品交期监控", permission: "btn_material_list", keepAlive: true },
          name: "WipDeliveryMonitoring"
        },
        {
          path: "/Report/WipCalledMaterial",
          component: resolve => require(["@/views/report/WipReport/WipCalledMaterial.vue"], resolve),
          meta: { title: "在制品叫料", permission: "btn_material_list", keepAlive: true },
          name: "WipCalledMaterial"
        },
        {
          path: "/Report/WipFeedMaterial",
          component: resolve => require(["@/views/report/WipReport/WipFeedMaterial.vue"], resolve),
          meta: { title: "在制品送料", permission: "btn_material_list", keepAlive: true },
          name: "WipFeedMaterial"
        },

        {
          path: "/Material/Material",
          component: resolve => require(["@/views/material/Material.vue"], resolve),
          meta: { title: "物料管理", permission: "btn_material_list", keepAlive: true },
          name: "Material"
        },
        {
          path: "/Material/BOM",
          component: resolve => require(["@/views/material/BOM.vue"], resolve),
          meta: { title: "BOM组装", permission: "btn_billOfMaterials_listBomByMaterial", keepAlive: true },
          name: "BOM"
        },
        { path: "/Stock/StoreManagement", component: StoreManagement, meta: { title: "仓库管理", permission: "btn_stock_list", keepAlive: true }, name: "StoreManagement" },
        { path: "/Stock/Repertory", component: Repertory, meta: { title: "库存", permission: "btn_stock_list", keepAlive: true }, name: "Repertory" },
        { path: "/Stock/NoticeOfArrival", component: NoticeOfArrival, meta: { title: "到货通知", permission: "btn_arrivalNotice_listArrivalNotice", keepAlive: true }, name: "NoticeOfArrival" },
        { path: "/Stock/IncomingInspection", component: IncomingInspection, meta: { title: "来料检验", permission: "btn_incomingInspection_list", keepAlive: true }, name: "IncomingInspection" },
        { path: "/Stock/RecordsOfStoreEnter", component: RecordsOfStoreEnter, meta: { title: "入库记录", permission: "btn_stockIn_listStockIn", keepAlive: true }, name: "RecordsOfStoreEnter" },
        { path: "/Stock/RecordsOfStoreOut", component: RecordsOfStoreOut, meta: { title: "出库记录", permission: "btn_stockOut_list", keepAlive: true }, name: "RecordsOfStoreOut" },
        { path: "/Stock/InventoryTask", component: InventoryTask, meta: { title: "盘点任务", permission: "btn_inventory_list", keepAlive: true }, name: "InventoryTask" },
        { path: "/Stock/InventoryRecords", component: InventoryRecords, meta: { title: "盘点记录", permission: "btn_stockCounting_list", keepAlive: true }, name: "InventoryRecords" },
        { path: "/Stock/PickMaterialTask", component: PickMaterialTask, meta: { title: "领料任务", permission: "btn_materialRequisition_list", keepAlive: true }, name: "PickMaterialTask" },
        { path: "/Stock/MonthlySummary", component: MonthlySummary, meta: { title: "月度汇总", permission: "btn_summary_list", keepAlive: true }, name: "MonthlySummary" },
        { path: "/Warning/Warning", component: Warning, meta: { title: "异常管理", permission: "btn_exception_list", keepAlive: true }, name: "warning" },
        { path: "/Warning/WarningIpc", component: WarningIpc, meta: { title: "报工一体机异常管理", permission: "btn_exception_list", keepAlive: true }, name: "warningIpc" },
        { path: "/Warning/DealConfig", component: DealConfig, meta: { title: "事件处理配置", permission: "btn_eventProcessConfig_list", keepAlive: true }, name: "dealConfig" },
        { path: "/Warning/ExceptionConfig", component: ExceptionConfig, meta: { title: "响应设置", permission: "btn_anomalyResponse_list", keepAlive: true }, name: "ExceptionConfig" },
        { path: "/Warning/ExceptionList", component: ExceptionList, meta: { title: "异常清单", permission: "btn_anomalyEvent_list", keepAlive: true }, name: "ExceptionList" },
        { path: "/PersonInfo", component: PersonInfo, meta: { title: "个人信息", keepAlive: true }, name: "PersonInfo" },
        { path: "/MasterData/RoleConf", component: RoleConf, meta: { title: "角色配置", permission: "btn_permission_list", keepAlive: true }, name: "RoleConf" },
        {
          path: "/MasterData/MasterDataConfig",
          component: MasterDataConfig,
          meta: { title: "主数据配置", permission: "btn_masterData_listProductionType", keepAlive: true },
          name: "MasterDataConfig"
        },
        { path: "/MasterData/CodeMgt", component: CodeMgt, meta: { title: "编码管理", permission: "btn_encode_page", keepAlive: true }, name: "CodeMgt" },
        { path: "/MasterData/Dictionary", component: Dictionary, meta: { title: "字典管理", permission: "btn_property_extend_list", keepAlive: true }, name: "Dictionary" },
        { path: "/MasterData/ClientMgt", component: ClientMgt, meta: { title: "客户管理", permission: "btn_customer_page", keepAlive: true }, name: "ClientMgt" },
        {
          path: "/MasterData/workingCalendar",
          component: WorkingCalendar,
          meta: { title: "工作日历", permission: "btn_calendarDate_listCalendarDateConfig", keepAlive: true },
          name: "WorkingCalendar"
        },
        { path: "/MasterData/OrganizationConf", component: OrganizationConf, meta: { title: "组织配置", permission: "btn_org_getOrgTree", keepAlive: true }, name: "OrganizationConf" },
        { path: "/MachineInterconnection/protocolMgt", component: ProtocolMgt, meta: { title: "协议模板管理", permission: "btn_protocol_list", keepAlive: true }, name: "protocolMgt" },
        { path: "/MachineInterconnection/alarmMgt", component: AlarmMgt, meta: { title: "规则管理", permission: "btn_alarmRule_list", keepAlive: true }, name: "alarmMgt" },
        { path: "/MachineInterconnection/alarmHistory", component: AlarmHistory, meta: { title: "告警历史", permission: "btn_alarmHistory_list", keepAlive: true }, name: "alarmHistory" },
        { path: "/MasterData/FactoryModel", component: FactoryModel, meta: { title: "工厂建模", permission: "btn_factoryModel_listFactoryModel", keepAlive: true }, name: "FactoryModel" },
        {
          path: "/Production/CapacityOfProduction",
          component: CapacityOfProduction,
          meta: { title: "产能负荷图", permission: "btn_order_listBusinessOrder", keepAlive: true },
          name: "CapacityOfProduction"
        },
        { path: "/ProductionTask", component: ProductionTask, meta: { title: "生产任务", permission: "btn_productionTask_list", keepAlive: true }, name: "ProductionTask" },
        { path: "/Production/SalesOrder", component: SalesOrder, meta: { title: "主计划管理", permission: "btn_order_listBusinessOrder", keepAlive: true }, name: "SalesOrder" },
        { path: "/Rework/ReworkTask", component: ProductionRework, meta: { title: "返工任务", permission: "btn_reworkPlan_listReworkPlan", keepAlive: true }, name: "ProductionRework" },
        { path: "/Rework/ReworkTechnology", component: ReworkTechnology, meta: { title: "返工工艺", permission: "btn_technology_list", keepAlive: true }, name: "ReworkTechnology" },
        { path: "/Rework/ReworkRecord", component: ReworkRecord, meta: { title: "返工任务", permission: "btn_reworkRecord_list", keepAlive: true }, name: "ReworkRecord" },
        { path: "/Rework/OtherRecord", component: OtherRecord, meta: { title: "其他任务", permission: "btn_other_task_list", keepAlive: true }, name: "OtherRecord" },
        {
          path: "/Rework/PerformanceInspect",
          component: PerformanceInspect,
          meta: { title: "执行组绩效核查", permission: "btn_production_plan_detail_execution_group_list", keepAlive: true },
          name: "PerformanceInspect"
        },

        {
          path: "/TechnologyBOM/ProcedureMapWorkshop",
          component: ProcedureMapWorkshop,
          meta: { title: "工序/工作中心配置", permission: "btn_procedureConfig_listConfig", keepAlive: true },
          name: "ProcedureMapWorkshop"
        },
        {
          path: "/TechnologyBOM/TechnologyTemplate",
          component: TechnologyTemplate,
          meta: { title: "工艺线路模板", permission: "btn_technologyTemplate_list", keepAlive: true },
          name: "TechnologyTemplate"
        },
        { path: "/TechnologyBOM/Technology", component: Technology, meta: { title: "工艺BOM", permission: "btn_technology_list", keepAlive: true }, name: "Technology" },
        // { path: "/Report/DispatchReport", component: DispatchReport, meta: { title: '派工报表', permission: 'btn_report_listDispatchReport', keepAlive: true }, name: 'DispatchReport'},
        // { path: "/Report/DispatchRecord", component: DispatchRecord, meta: { title: '报工流水表', permission: 'btn_report_listDispatchReport', keepAlive: true }, name: 'DispatchRecord'},

        { path: "/trace/TraceList", component: TraceList, meta: { title: "追溯管理", permission: "btn_order_listBusinessOrder", keepAlive: true }, name: "TraceList" },
        { path: "/alarm/ExceptionSet", component: ExceptionSet, meta: { title: "异常上报类型", permission: "btn_user_listUserMgt", keepAlive: true }, name: "ExceptionSet" },
        { path: "/activation/activationList", component: Activation, meta: { title: "激活码", permission: "btn_user_listUserMgt", keepAlive: true }, name: "Activation" },
        {
          path: "/ProductTracking/ForwardTracking",
          component: ForwardTracking,
          meta: { title: "正向追溯", permission: "btn_productionTraceability_forwardTracing", keepAlive: true },
          name: "ForwardTracking"
        },
        {
          path: "/ProductTracking/ReverseTracking",
          component: ReverseTracking,
          meta: { title: "反向追溯", permission: "btn_productionTraceability_backwardTracing", keepAlive: true },
          name: "ReverseTracking"
        },

        { path: "/Report/ProductionReport", component: ProductionReport, meta: { title: "生产报表", keepAlive: true }, name: "ProductionReport" },
        {
          path: "/Report/ProductionReport/ProcedureReport",
          component: resolve => require(["@/views/report/productionReport/ProcedureReport.vue"], resolve),
          meta: { title: "工序日产量统计", keepAlive: true },
          name: "ProcedureReport"
        },
        {
          path: "/Report/ProductionReport/WorkshopReport",
          component: resolve => require(["@/views/report/productionReport/WorkshopReport.vue"], resolve),
          meta: { title: "工单日产量统计", keepAlive: true },
          name: "WorkshopReport"
        },
        {
          path: "/Report/ProductionReport/OrderReport",
          component: resolve => require(["@/views/report/productionReport/OrderReport.vue"], resolve),
          meta: { title: "订单产量统计", keepAlive: true },
          name: "OrderReport"
        },
        {
          path: "/Report/ProductionReport/DeviceReport",
          component: resolve => require(["@/views/report/productionReport/DeviceReport.vue"], resolve),
          meta: { title: "设备日产量统计", keepAlive: true },
          name: "DeviceReport"
        },
        {
          path: "/Report/ProductionReport/WipReport",
          component: resolve => require(["@/views/report/productionReport/WipReport.vue"], resolve),
          meta: { title: "在制品统计", keepAlive: true },
          name: "WipReport"
        },
        {
          path: "/Report/ProductionReport/CustomerReport",
          component: resolve => require(["@/views/report/productionReport/CustomerReport.vue"], resolve),
          meta: { title: "客户日产量报表", keepAlive: true },
          name: "CustomerReport"
        },
        {
          path: "/Report/ProductionReport/MachineReport",
          component: resolve => require(["@/views/report/productionReport/MachineReport.vue"], resolve),
          meta: { title: "机组日产量报表", keepAlive: true },
          name: "MachineReport"
        },
        {
          path: "/Report/ProductionReport/ProductionCosts",
          component: resolve => require(["@/views/report/productionReport/ProductionCosts.vue"], resolve),
          meta: { title: "生产成本报表", keepAlive: true },
          name: "ProductionCosts"
        },

        { path: "/Report/UserReport", component: resolve => require(["@/views/report/userReport/index.vue"], resolve), meta: { title: "员工报表", keepAlive: true }, name: "UserReport" },
        {
          path: "/Report/UserReport/DispatchRecord",
          component: resolve => require(["@/views/report/userReport/DispatchRecord.vue"], resolve),
          meta: { title: "报工流水表", keepAlive: true },
          name: "DispatchRecord"
        },
        {
          path: "/Report/UserReport/PerformanceReport",
          component: resolve => require(["@/views/report/userReport/PerformanceReport.vue"], resolve),
          meta: { title: "报工绩效表", keepAlive: true },
          name: "PerformanceReport"
        },
        {
          path: "/Report/UserReport/YHPerformanceReport",
          component: resolve => require(["@/views/report/userReport/YHPerformanceReport.vue"], resolve),
          meta: { title: "报工绩效表", keepAlive: true },
          name: "YHPerformanceReport"
        },
        { path: "/Report/ExceptionReport", component: resolve => require(["@/views/report/exceptionReport/index.vue"], resolve), meta: { title: "异常分析报表", keepAlive: true }, name: "UserReport" },

        { path: "/Report/QualityReport", component: resolve => require(["@/views/report/qualityReport/index.vue"], resolve), meta: { title: "质量分析报表", keepAlive: true }, name: "QualityReport" },
        { path: "/Report/deviceIndex", component: resolve => require(["@/views/report/equipmentReport/index.vue"], resolve), meta: { title: "设备报表", keepAlive: true }, name: "EquipIndex" },
        // { path: "/Report/QualityReport", component: QualityReport, meta: { title: '质检报表', permission: 'btn_qcDashBoard_get', keepAlive: true }, name: 'QualityReport'},
        {
          path: "/Report/equipmentReport/equipmentEfficiency",
          component: resolve => require(["@/views/report/equipmentReport/equipmentEfficiency.vue"], resolve),
          meta: { title: "设备效率", keepAlive: true },
          name: "EquipmentEfficiency"
        },
        {
          path: "/Report/equipmentReport/equipmentWarning",
          component: resolve => require(["@/views/report/equipmentReport/equipmentWarning.vue"], resolve),
          meta: { title: "设备告警", keepAlive: true },
          name: "EquipmentWarning"
        },
        {
          path: "/Report/equipmentReport/equipmentRepair",
          component: resolve => require(["@/views/report/equipmentReport/equipmentRepair.vue"], resolve),
          meta: { title: "设备维修", keepAlive: true },
          name: "EquipmentRepair"
        },
        {
          path: "/Report/equipmentReport/personnelRepair",
          component: resolve => require(["@/views/report/equipmentReport/personnelRepair.vue"], resolve),
          meta: { title: "人员维修", keepAlive: true },
          name: "PersonnelRepair"
        },
        {
          path: "/Report/equipmentReport/equipmentMaintenance",
          component: resolve => require(["@/views/report/equipmentReport/equipmentMaintenance.vue"], resolve),
          meta: { title: "设备保养", keepAlive: true },
          name: "EquipmentMaintenance"
        },
        {
          path: "/Report/equipmentReport/personnelMaintenance",
          component: resolve => require(["@/views/report/equipmentReport/personnelMaintenance.vue"], resolve),
          meta: { title: "人员保养", keepAlive: true },
          name: "PersonnelMaintenance"
        },
        {
          path: "/Report/equipmentReport/equipmentSpotCheck",
          component: resolve => require(["@/views/report/equipmentReport/equipmentSpotCheck.vue"], resolve),
          meta: { title: "设备点检", keepAlive: true },
          name: "EquipmentSpotCheck"
        },
        {
          path: "/Report/equipmentReport/personnelSpotCheck",
          component: resolve => require(["@/views/report/equipmentReport/personnelSpotCheck.vue"], resolve),
          meta: { title: "人员点检", keepAlive: true },
          name: "PersonnelSpotCheck"
        },
        { path: "/Report/DeviceReport", component: resolve => require(["@/views/report/deviceReport/index.vue"], resolve), meta: { title: "设备分析报表", keepAlive: true }, name: "DeviceReport" },
        { path: "/Report/energyIndex", component: resolve => require(["@/views/report/energyReport/index.vue"], resolve), meta: { title: "能耗报表", keepAlive: true }, name: "EnergyReport" },
        {
          path: "/Report/energyReport/energyReport",
          component: resolve => require(["@/views/report/energyReport/EnergyReport.vue"], resolve),
          meta: { title: "能耗报表", keepAlive: true },
          name: "EnergyReport"
        },

        { path: "/Order/Plan", component: resolve => require(["@/views/deviceOrder/orderPlan.vue"], resolve), meta: { title: "保养计划", keepAlive: true }, name: "OrderPlan" },
        { path: "/Order/Task", component: resolve => require(["@/views/deviceOrder/orderTask.vue"], resolve), meta: { title: "保养任务", keepAlive: true }, name: "OrderTask" },
        { path: "/Order/Tep", component: resolve => require(["@/views/deviceOrder/orderTep.vue"], resolve), meta: { title: "保养模板", keepAlive: true }, name: "OrderTep" },
        { path: "/Spot/Plan", component: resolve => require(["@/views/deviceSpot/spotPlan.vue"], resolve), meta: { title: "点检计划", keepAlive: true }, name: "SpotPlan" },
        { path: "/Spot/Task", component: resolve => require(["@/views/deviceSpot/spotTask.vue"], resolve), meta: { title: "点检任务", keepAlive: true }, name: "SpotTask" },
        { path: "/Spot/Tep", component: resolve => require(["@/views/deviceSpot/spotTep.vue"], resolve), meta: { title: "点检模板", keepAlive: true }, name: "SpotTep" },
        { path: "/DeviceCare/Repair", component: resolve => require(["@/views/devicecare/DeviceRepair.vue"], resolve), meta: { title: "维修任务", keepAlive: true }, name: "DeviceRepair" },
        { path: "/DeviceCare/PartsWaring", component: resolve => require(["@/views/devicecare/PartsWaring.vue"], resolve), meta: { title: "设备零件预警", keepAlive: true }, name: "PartsWaring" },

        // 数据采集
        { path: "/Collection/Equipment", component: resolve => require(["@/views/deviceLine/index.vue"], resolve), meta: { title: "机联管理", keepAlive: true }, name: "DeviceIndex" },
        { path: "/Collection/Equipment/:code", component: resolve => require(["@/views/deviceLine/pointLocation.vue"], resolve), meta: { title: "点位", keepAlive: true }, name: "PointLocation" },
        { path: "/Collection/AlarmList", component: resolve => require(["@/views/warning/warningList.vue"], resolve), meta: { title: "告警清单", keepAlive: true }, name: "AlarmList" },
        { path: "/Collection/AlarmSetting", component: resolve => require(["@/views/warning/warningSetting.vue"], resolve), meta: { title: "告警设置", keepAlive: true }, name: "AlarmSetting" },
        { path: "/Collection/command", component: resolve => require(["@/views/deviceLine/command.vue"], resolve), meta: { title: "指令管理", keepAlive: true }, name: "Command" },

        // 嵌入第三方地址
        { path: "/erp/iframe/:id", component: ERPIframe, meta: { title: "erp", keepAlive: true }, name: "ERPIframe" },
        // { path: "/erp/iframe/447", component:ERPIframe , meta: { title: "erp", keepAlive: true }, name: "ERPIframe" },
        // { path: "/erp/iframe/448", component:ERPIframe , meta: { title: "erp", keepAlive: true }, name: "ERPIframe" },
        // { path: "/erp/iframe/449", component:ERPIframe , meta: { title: "erp", keepAlive: true }, name: "ERPIframe" },

        // 出入库管理
        {
          path: "/OutputinStorage/OutsourcedDeliver",
          component: resolve => require(["@/views/OutputinStorage/OutsourcedDeliver.vue"], resolve),
          meta: { title: "外协发货", keepAlive: true },
          name: "OutsourcedDeliver"
        },
        {
          path: "/OutputinStorage/OutsourcedArrival",
          component: resolve => require(["@/views/OutputinStorage/OutsourcedArrival.vue"], resolve),
          meta: { title: "外协到货", keepAlive: true },
          name: "OutsourcedArrival"
        },
        {
          path: "/OutputinStorage/OutsourcedReport",
          component: resolve => require(["@/views/OutputinStorage/OutsourcedReport.vue"], resolve),
          meta: { title: "外协统计报表", keepAlive: true },
          name: "OutsourcedReport"
        },
        {
          path: "/OutputinStorage/ReturnMaterials",
          component: resolve => require(["@/views/OutputinStorage/ReturnMaterials.vue"], resolve),
          meta: { title: "退领料管理", keepAlive: true },
          name: "ReturnMaterials"
        }
      ]
    },
    {
      path: "/Login",
      component: resolve => require(["@/views/Login.vue"], resolve),
      name: "Login",
      meta: {
        title: "登录-物源科技"
      }
    },
    {
      path: "/PrintAll",
      component: resolve => require(["@/views/print/PrintAll.vue"], resolve),
      name: "PrintAll",
      meta: {
        title: "批量打印"
      }
    },
    {
      path: "/PrintAllOrder",
      component: resolve => require(["@/views/print/PrintAllOrder.vue"], resolve),
      name: "PrintAllOrder",
      meta: {
        title: "批量打印流转卡"
      }
    },
    {
      path: "/Print/PrintPickMaterial",
      component: resolve => require(["@/views/print/PrintPickMaterial.vue"], resolve),
      name: "PrintPickMaterial",
      meta: {
        title: "打印领料任务"
      }
    },

    {
      path: "/Print/PrintStock",
      component: resolve => require(["@/views/print/printStock.vue"], resolve),
      name: "PrintStock",
      meta: {
        title: "出库记录"
      }
    },
    {
      path: "/ProductBillboard",
      component: resolve => require(["@/views/billboard/ProductBillboard.vue"], resolve),
      name: "ProductBillboard",
      permission: "btn_indexInfo_getBoard",
      meta: { title: "生产进度看板" }
    },
    {
      path: "/qualityboard",
      component: resolve => require(["@/views/billboard/QualityBoard.vue"], resolve),
      name: "Qualityboard",
      permission: "btn_indexInfo_getBoard",
      meta: { title: "质量看板" }
    },
    {
      path: "/Machineboard",
      component: resolve => require(["@/views/billboard/MachineBoard.vue"], resolve),
      name: "Machineboard",
      permission: "btn_indexInfo_getBoard",
      meta: { title: "机联看板" }
    },
    {
      path: "/deviceboard",
      component: resolve => require(["@/views/billboard/DeviceBoard.vue"], resolve),
      name: "Deviceboard",
      permission: "btn_indexInfo_getBoard",
      meta: { title: "设备看板" }
    },
    {
      path: "/allboard",
      component: resolve => require(["@/views/billboard/Allboard.vue"], resolve),
      name: "allboard",
      permission: "btn_indexInfo_getBoard",
      meta: { title: "看板轮播" }
    },
    {
      path: "/WarningBillboard",
      component: resolve => require(["@/views/billboard/WarningBillboard.vue"], resolve),
      name: "WarningBillboard",
      permission: "btn_AppKanban_everydayExceptionCount",
      meta: { title: "异常管理看板" }
    },
    {
      path: "/WorkShopBoard",
      component: resolve => require(["@/views/billboard/WorkShopBoard.vue"], resolve),
      name: "WorkShopBoard",
      permission: "btn_AppKanban_everydayExceptionCount",
      meta: { title: "机组看板" }
    },
    {
      path: "/ProcessBoard",
      component: resolve => require(["@/views/billboard/ProcessBoard.vue"], resolve),
      name: "ProcessBoard",
      permission: "btn_AppKanban_everydayExceptionCount",
      meta: { title: "在制品看板" }
    },
    {
      path: "/ProcessDashboard",
      component: resolve => require(["@/views/billboard/ProcessDashboard.vue"], resolve),
      name: "ProcessDashboard",
      permission: "btn_AppKanban_everydayExceptionCount",
      meta: { title: "生产交期监控看板" }
    },
    // {
    //   path: "/DeviceBoard",
    //   component: resolve => require(["@/views/billboard/DeviceBoard.vue"], resolve),
    //   name: "DeviceBoard",
    //   permission: "btn_AppKanban_everydayExceptionCount",
    //   meta: { title: "设备机联看板" }
    // },
    {
      path: "/DigitizationBoard",
      component: resolve => require(["@/views/billboard/DigitizationBoard.vue"], resolve),
      name: "DigitizationBoard",
      permission: "btn_AppKanban_everydayExceptionCount",
      meta: { title: "数字化监控大屏" }
    },
    {
      path: "/ProductionMonitoringBoard",
      component: resolve => require(["@/views/billboard/ProductionMonitoringBoard.vue"], resolve),
      name: "ProductionMonitoringBoard",
      permission: "btn_AppKanban_everydayExceptionCount",
      meta: { title: "生产监控大屏" }
    },
    {
      path: "/WorkInProcessCallBoard",
      component: resolve => require(["@/views/billboard/WorkInProcessCallBoard.vue"], resolve),
      name: "WorkInProcessCallBoard",
      permission: "btn_AppKanban_everydayExceptionCount",
      meta: { title: "在制品呼叫看板" }
    },
    {
      path: "/XYGDeviceBoard",
      component: resolve => require(["@/views/billboard/XYGDeviceBoard.vue"], resolve),
      name: "XYGDeviceBoard",
      permission: "btn_AppKanban_everydayExceptionCount",
      meta: { title: "新阳光机联看板" }
    },
    {
      path: "/XYGProcedureBoard",
      component: resolve => require(["@/views/billboard/XYGProcedureBoard.vue"], resolve),
      name: "/XYGProcedureBoard",
      permission: "btn_AppKanban_everydayExceptionCount",
      meta: { title: "新阳光工单进度看板" }
    },
    {
      path: "/XYGWorkShopBoard",
      component: resolve => require(["@/views/billboard/XYGWorkShopBoard.vue"], resolve),
      name: "XYGWorkShopBoard",
      permission: "btn_AppKanban_everydayExceptionCount",
      meta: { title: "新阳光机组进度看板" }
    },

    {
      path: "/HuizhengProductBoard",
      component: resolve => require(["@/views/billboard/HuizhengProductBoard.vue"], resolve),
      name: "HuizhengProductBoard",
      permission: "btn_AppKanban_everydayExceptionCount",
      meta: { title: "汇正生产看板" }
    },
    {
      path: "/RuixingProductBoard",
      component: resolve => require(["@/views/billboard/RuixingProductBoard.vue"], resolve),
      name: "RuixingProductBoard",
      permission: "btn_AppKanban_everydayExceptionCount",
      meta: { title: "瑞兴生产看板" }
    },

    {
      path: "/Print/PrintPurchase",
      component: resolve => require(["@/views/print/PrintPurchase.vue"], resolve),
      name: "PrintPurchase",
      meta: {
        title: "采购订单"
      }
    },
    {
      path: "/Print/PrintDispatchTask",
      component: resolve => require(["@/views/print/PrintDispatchTask.vue"], resolve),
      name: "PrintDispatchTask",
      meta: {
        title: "派工单"
      }
    },
    {
      path: "/webAppBoard",
      component: resolve => require(["@/views/billboard/AllboardApp.vue"], resolve),
      name: "webAppBoard",
      meta: {
        title: "看板"
      }
    }
  ],
  history: true,
  saveScrollPosition: true
});



// WEBPACK FOOTER //
// ./src/router/index.js